import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL || ""}/api`;
export const api = axios.create({ baseURL: API, withCredentials: true });
export const fileUrl = (path) => (path ? `${API}/files/${path}` : null);

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (typeof x?.msg === "string" ? x.msg : JSON.stringify(x))).join(" ");
  return typeof d?.msg === "string" ? d.msg : String(d);
}

export const PHONE_DISPLAY = "(781) 964-5990";
export const PHONE_TEL = "tel:+17819645990";
export const PHONE2_DISPLAY = "(978) 828-0199";
export const PHONE2_TEL = "tel:+19788280199";
export const EMAIL = "contact@smartkeyboston.com";
export const DOMAIN = "smartkeyboston.com";
export const WHATSAPP_NUMBER = "17819645990";
export const SOCIALS = [
  { id: "whatsapp", type: "whatsapp", label: "WhatsApp (781) 964-5990", url: "https://wa.me/17819645990" },
  { id: "instagram", type: "instagram", label: "@smartkeyofboston", url: "https://www.instagram.com/smartkeyofboston?exln=ZWE2djVvZjFqeTM4" },
  { id: "facebook-chaveiro-boston", type: "facebook", label: "Chaveiro Boston", url: "https://www.facebook.com/share/19TPZkzKQ7/?mibextid=wwXIfr" },
  { id: "facebook-smart-key-of-boston", type: "facebook", label: "Smart Key of Boston", url: "https://www.facebook.com/share/1C9VFYHpsh/?mibextid=wwXIfr" },
];
